import GreenhouseGasEmissionOrganization from './GreenhouseGasEmissionOrganization';

export default GreenhouseGasEmissionOrganization;
